import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'createLogger'
import activitiesManagerStore from '@/activities-manager/store'

Vue.use(Vuex)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : [],
  modules: {},
  state: {},
  mutations: {},
  actions: {}
})

export const importWechatModules = async (getModule, config) => {
  const module = (await getModule()).default
  Object.assign(module.store.moduleSetting.state, config.module.elements)
  store.registerModule('moduleSetting', module.store.moduleSetting)
  Object.assign(module.store.eventRuntime.state, config)
  store.registerModule('eventRuntime', module.store.eventRuntime)
}

export const importActivitiesManagerModules = async data => {
  if (data.config) {
    const config = typeof (data.config) === 'string' ? JSON.parse(data.config) : data.config
    Object.assign(data, config)
    delete data.config
  }

  Object.assign(activitiesManagerStore.state, data)
  store.registerModule('activitiesManager', activitiesManagerStore)
}

export default store